// Actions
import { SHOW_TOOLTIP, HIDE_TOOLTIP } from '../actions/createTooltip';

const init = {
  data: {},
  visible: false,
};

export default function resize(state = init, action) {
  switch (action.type) {
    case SHOW_TOOLTIP:
      return { data: action.data, visible: true };

    case HIDE_TOOLTIP:
      return { ...state, visible: false };

    default:
      return state;
  }
}
